export const steps = [
  {
    title: 'Generate initial creatives',
    description: 'AI creates 5 brand-specific ads in under 30 seconds'
  },
  {
    title: 'Choose your plan',
    description: 'Pick the plan that fits your needs'
  }
];
